import { render, staticRenderFns } from "./shopInventory.vue?vue&type=template&id=5a263f42&scoped=true"
import script from "./shopInventory.vue?vue&type=script&lang=js"
export * from "./shopInventory.vue?vue&type=script&lang=js"
import style0 from "./shopInventory.vue?vue&type=style&index=0&id=5a263f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a263f42",
  null
  
)

export default component.exports